import React from 'react'

import { AddProjectButton } from '../buildings_page/components/AddProjectButton'
import {
  CardBase,
  CardDesc,
  CardDescItem,
  CardImage,
  CardTitle,
  CardTitleInner,
} from '../buildings_page/components/Card'

const defaultLogoStyle: React.CSSProperties = {
  width: '112px',
  height: '112px',
  objectFit: 'contain',
  margin: '20px auto 0',
  display: 'block',
}

type IntegrationAuthCardProps = {
  logoSrc: string
  title: string
  description: string
  authenticateLabel: string
  isLinked: boolean
  loginUrl: string | null
  logoStyle?: React.CSSProperties
}

export const IntegrationAuthCard = ({
  logoSrc,
  title,
  description,
  authenticateLabel,
  isLinked,
  loginUrl,
  logoStyle,
}: IntegrationAuthCardProps) => {
  const openLoginUrl = () => {
    if (!isLinked && loginUrl) {
      window.location.href = loginUrl
    }
  }

  return (
    <CardBase
      onClick={openLoginUrl}
      style={{
        cursor: isLinked || !loginUrl ? 'default' : 'pointer',
      }}
    >
      <CardImage src={logoSrc} style={{ ...defaultLogoStyle, ...logoStyle }} />
      <CardTitle>
        <CardTitleInner>{title}</CardTitleInner>
      </CardTitle>
      <CardDesc
        style={{
          marginTop: '5px',
          display: 'block',
        }}
      >
        <CardDescItem style={{ whiteSpace: 'normal', lineHeight: '20px' }}>
          {description}
        </CardDescItem>
        <CardDescItem
          style={{
            marginTop: '20px',
          }}
        >
          {isLinked && 'Account linked successfully'}
          {!isLinked && loginUrl && (
            <AddProjectButton text={authenticateLabel} />
          )}
          {!isLinked && !loginUrl && (
            <span
              style={{ color: '#666', fontSize: '13px', lineHeight: '18px' }}
            >
              Authentication is not configured for this environment.
            </span>
          )}
        </CardDescItem>
      </CardDesc>
    </CardBase>
  )
}
